import React, { ReactNode } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { touchNavHeaderRowSx } from '../common/touchTargetSx';
import {
  dashboardSectionPaperSx,
  dashboardSectionTitleSx,
} from './dashboardMuiStyles';

type DashboardSectionProps = {
  title: string;
  action?: ReactNode;
  children: ReactNode;
};

export const DashboardSection = ({
  title,
  action,
  children,
}: DashboardSectionProps) => (
  <Paper variant="outlined" sx={dashboardSectionPaperSx}>
    <Box
      sx={{
        ...touchNavHeaderRowSx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mb: { xs: 1.5, xxl: 1.75, xxxl: 2 },
      }}
    >
      <Typography
        variant="h6"
        component="h2"
        sx={dashboardSectionTitleSx}
      >
        {title}
      </Typography>
      {action}
    </Box>
    {children}
  </Paper>
);

export default DashboardSection;
